export const GET_VEHICLE_TYPES_REQUEST = "GET_VEHICLE_TYPES_REQUEST";
export const GET_VEHICLE_TYPES_SUCCESS = "GET_VEHICLE_TYPES_SUCCESS";
export const GET_VEHICLE_TYPES_FAIL = "GET_VEHICLE_TYPES_FAIL";
